import type {
  InviteAccountUserCommand,
  InviteAccountUserResult,
} from "@/domain/model/AccountSeatOverview";
import type { AccountManagementService } from "@/domain/port/AccountManagementService";

export class InviteAccountUser {
  constructor(private readonly service: AccountManagementService) {}

  execute(
    command: InviteAccountUserCommand,
    signal?: AbortSignal,
  ): Promise<InviteAccountUserResult> {
    return this.service.inviteAccountUser(command, signal);
  }
}
